import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import * as actions from '../actions';
import UpdatesView from '../view/UpdatesView';

class Updates extends React.Component {
	constructor(props) {
		super(props);
		this.fetchUpdates = this.fetchUpdates.bind(this);
	}

	fetchUpdates() {
		this.props.actions.fetchUpdates();
	}

	render() {
		const { loading, error, errorDetail, updates, productName } = this.props;

		if (error) {
			return <ErrorPage errorDetail={errorDetail} />;
		} else if (loading || !updates) {
			return <ContentLoading />;
		} else {
			return (
				<UpdatesView
					productName={productName}
					updates={updates}
				/>
			);
		}
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		productName: state.system && state.system.config
			? state.system.config.productName : '',
		updates: state.updates.updates,
		error: state.updates.error,
		errorDetail: state.updates.errorDetail,
		loading: state.updates.loading
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Updates);
